export const COMPANY_NAME = 'SchooLinks';
export const COMPANY_DESCRIPTION =
  'Discover your career, major and get matched to university that will fit you. We keep you on track for college planning and application.';
export const CATALOG_TITLE = 'View your course catalog';
export const CATALOG_DESCRIPTION =
  "View your school's catalog by clicking the button below. Use it to help you fulfill your graduation requirements and make decisions about what courses to take.";
export const DOWNLOAD_CATALOG = 'Download Catalog';
export const NEXT_STEP = 'Next Step';
export const CHOOSE_A_CAREER_PATHWAY = 'Choose a career pathway';
export const CHOOSE_A_CAREER_CLUSTER =
  'Step 1. Choose a Schoolinks career cluster';
export const YOUR_SELECTED_CAREER_CLUSTER = 'Your Selected Career Cluster.';
export const RELATED_HIGH_SCHOOL_PATHWAYS = 'Related High School Pathways:';
export const CONTINUE = 'Continue >';
export const REQUIREMENT_TITLE =
  'Choose a sequence to satisfy this requirement';
export const NINETH = '9th';
export const TENTH = '10th';
export const ELEVENTH = '11th';
export const TWELVETH = '12th';
export const FRESHMAN = 'Freshman Year';
export const SOPHOMORE = 'Sophomore Year';
export const JUNIOR = 'Junior Year';
export const SENIOR = 'Senior Year';
export const PLANNER_REVIEW = 'Your Course Plan Overview';
export const SUBMIT_PLAN = 'Submit Plan';
